"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = exports.ProgressBarContainer = exports.VarCorrelationTableBarCell = exports.VarCorrelationTableCorrelationCell = exports.VarCorrelationTableNameCell = exports.VarCorrelationTableCellBorder = exports.VarCorrelationTableWithChart = void 0;
var typestyle_1 = require("typestyle");
var colors = require("../util/colors");
require("@tableau/fonts-tableau");
exports.VarCorrelationTableWithChart = typestyle_1.style({
    backgroundColor: colors.white,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: '0.2px',
    color: colors.tableauGray11,
    width: '100%',
});
var cellStyleCommon = {
    height: '40px',
};
exports.VarCorrelationTableCellBorder = typestyle_1.style({
    borderBottom: '1px solid ' + colors.tableauGray05,
});
exports.VarCorrelationTableNameCell = typestyle_1.style(__assign(__assign({}, cellStyleCommon), { paddingLeft: '8px' }));
exports.VarCorrelationTableCorrelationCell = typestyle_1.style(__assign(__assign({}, cellStyleCommon), { textAlign: 'right' }));
exports.VarCorrelationTableBarCell = typestyle_1.style(__assign(__assign({}, cellStyleCommon), { width: '55%' }));
exports.ProgressBarContainer = typestyle_1.style({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
});
exports.ProgressBar = typestyle_1.style({
    height: '80%',
});
//# sourceMappingURL=VariableCorrelationTable.js.map